import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_COACH_INFO_SAGA } from "../sagaTypes";
import { loadingAction, setCoachInfoAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';

const request = data => {
    return fetch(`${ url }/get_coach_info`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetCoachInfo(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('coach_id', args.data.coach_id);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            yield put(setCoachInfoAction(response.payload));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetCoachInfo() {
    yield takeLatest(GET_COACH_INFO_SAGA, workerGetCoachInfo);
}